import React from 'react'
import { Grid, makeStyles, Typography, Tooltip } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#d7f2ff',
    color: '#0095ff',
    padding: theme.spacing(1, 1, 1, 6),
    border: '1px solid #0095ff',
    borderRadius: '4px 4px 0 0'
  },
  robotHead: {
    height: theme.spacing(5)
  }
}))

const tooltipMessage =
  'Com base nos dados da ficha, o sistema fez uma pré validação e encontrou inconsistências nos documentos do Motorista, Proprietário e/ou veículos. Com base nisso, é necessário conferir quais dados estão divergentes e avaliar a liberação.'

export const AnaliseDocumentoIndicator = () => {
  const classes = useStyles()

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className={classes.container}
    >
      <Grid item>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={1}
        >
          <Grid item>
            <img src="/robot-head.svg" alt="" className={classes.robotHead} />
          </Grid>
          <Grid item>
            <Typography>Análise de Documentos</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={1}
        >
          <Grid item>
            <Typography>O que é isso?</Typography>
          </Grid>
          <Grid item>
            <Tooltip placement="top" title={tooltipMessage}>
              <InfoOutlinedIcon fontSize="medium" />
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
